// extracted by mini-css-extract-plugin
module.exports = {"editor":"RichTextWidget_editor__3wD5q"};